import { render, staticRenderFns } from "./Aelteste.vue?vue&type=template&id=037da51f&"
import script from "./Aelteste.vue?vue&type=script&lang=js&"
export * from "./Aelteste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports